// extracted by mini-css-extract-plugin
export default {"block":"BusinessCards_block__TJ4i+"};